import { axiosPrivate, getSequencer, getLocale } from ".";

export const logInAffiliate = (email, senha, recaptcha) =>
  axiosPrivate.post(
    "loja/afiliado/login",
    {
      email: email,
      senha: senha,
      captcha: recaptcha,
    },
    { cache: true }
  );

export const changePasswordAffiliate = (id, oldPass, newPass) =>
  axiosPrivate.put(
    `loja/afiliado/trocarSenha/${id}`,
    {
      senha_antiga: oldPass,
      senha_nova: newPass,
    },
    { cache: true }
  );

export const getAffiliates = (loja, limite, pagina, status, nome) =>
  axiosPrivate.post(
    "loja/afiliado/listar",
    {
      loja: loja,
      limite: limite,
      pagina: pagina,
      status: status,
      nome: nome,
    },
    { cache: true }
  );

export const getAffiliatesPrograms = (
  limite,
  pagina,
  status,
  nome,
  data_inicial,
  data_final
) =>
  axiosPrivate.post(
    `loja/programa/listar`,
    {
      loja: getSequencer(),
      limite: limite,
      pagina: pagina,
      status: status,
      nome: nome,
      data_inicial: data_inicial,
      data_final: data_final,
    },
    { cache: true }
  );

export const changeStatusAffiliate = (id, status) =>
  axiosPrivate.put(
    `loja/afiliado/status/${id}`,
    {
      idafiliado: id,
      status: status,
    },
    { cache: true }
  );

export const changeStatusAffiliateProgram = (id, status) =>
  axiosPrivate.put(
    `loja/programa/alterar`,
    {
      loja: getSequencer(),
      idprograma: id,
      status: status,
    },
    { cache: true }
  );

export const postAffiliate = params =>
  axiosPrivate.post(
    `loja/afiliado/cadastro/novo`,
    {
      afiliados: params,
    },
    { cache: true }
  );

export const importAffiliates = params =>
  axiosPrivate.post(
    `loja/afiliado/cadastro/novo`,
    {
      ...params,
    },
    { cache: true }
  );

export const registerAffiliate = (
  idprogramaafiliado,
  nome,
  email,
  telefone,
  cpf,
  slug,
  senha,
  termo
) =>
  axiosPrivate.post(
    `loja/afiliado/cadastro`,
    {
      idprogramaafiliado: idprogramaafiliado,
      nome: nome,
      email: email,
      senha: senha,
      telefone: telefone,
      cpf: cpf,
      slug: slug,
      status: "ATIVO",
      dthr_aceite_termo: termo,
    },
    { cache: true }
  );

export const createAffiliateProgram = (
  nome,
  slug,
  taxa_comissao,
  valor_desconto,
  perc_desconto,
  tipo_comissao,
  limite,
  emails,
  idproduto,
  nidproduto_variacao,
  status
) =>
  axiosPrivate.post(
    `loja/programa/cadastro`,
    {
      loja: getSequencer(),
      nome: nome,
      slug: slug,
      taxa_comissao: taxa_comissao,
      valor_desconto: valor_desconto,
      perc_desconto: perc_desconto,
      tipo_comissao: tipo_comissao,
      limite: limite,
      emails: emails,
      idproduto: idproduto,
      nidproduto_variacao: nidproduto_variacao,
      status: status,
    },
    { cache: true }
  );

export const getAffiliatesByProgramId = id =>
  axiosPrivate.get(`/afiliado/${id}`, { cache: true });

export const changeProgramAffiliate = (idprograma, emails) =>
  axiosPrivate.post(
    `loja/programa/cadastro/afiliado`,
    {
      loja: getSequencer(),
      idprograma: idprograma,
      emails: emails,
    },
    { cache: true }
  );

export const getInfoProgramByProgramId = id =>
  axiosPrivate.get(`/programa/${id}`, { cache: true });

export const getSaleByAffiliateId = (id, pesquisar) =>
  axiosPrivate.post(
    `loja/afiliado/vendas`,
    {
      idafiliado: id,
      pesquisar: pesquisar,
    },
    { cache: true }
  );

export const getTerms = idafiliado =>
  axiosPrivate.post(`loja/afiliado/termos`, { idafiliado }, { cache: true });

export const getDocTerm = () =>
  axiosPrivate.get(`programa/termo/afiliado`, { cache: true });

export const signDoc = idprogramaafiliado =>
  axiosPrivate.put(`loja/afiliado/atualizar/${idprogramaafiliado}`, {
    cache: true,
  });

export const getProgramListByAffiliateId = id =>
  axiosPrivate.post(
    `loja/afiliado/listarprogramas`,
    {
      idafiliado: id,
    },
    { cache: true }
  );

export const getInfoPreRegister = id =>
  axiosPrivate.get(`afiliado/getDados/${id}`, { cache: true });

export const sendEmailRecoverPassword = (email, url, captcha) =>
  axiosPrivate.post(
    `loja/afiliado/recuperarSenha`,
    {
      email: email,
      url: url,
      idioma: getLocale(),
      captcha: captcha,
    },
    { cache: true }
  );

export const recoveryPassword = (email, senha, token) =>
  axiosPrivate.put(
    `loja/afiliado/trocarSenhaToken`,
    {
      email: email,
      senha: senha,
      token: token,
    },
    { cache: true }
  );

export const editAffiliate = (id, name, phone, cpf, slug) =>
  axiosPrivate.put(
    `loja/afiliado/alterar/${id}`,
    {
      nome: name,
      cpf: cpf,
      telefone: phone,
      slug: slug,
    },
    { cache: true }
  );

export const getRanking = idprograma =>
  axiosPrivate.get(`afiliado/ranking/${idprograma}`, { cache: true });

export const resendEmail = (idprograma, idafiliado) =>
  axiosPrivate.post(
    `loja/afiliado/reenviar`,
    {
      idprograma: idprograma,
      idafiliado: idafiliado,
      loja: getSequencer(),
    },
    { cache: true }
  );

export const postCoupon = (idprograma, idafiliado, cupom) =>
  axiosPrivate.post(
    `loja/afiliado/cupom`,
    {
      idprograma: idprograma,
      idafiliado: idafiliado,
      cupom: cupom,
    },
    { cache: true }
  );

export const getSalesByAffiliateConsumer = (id, status, pesquisar) =>
  axiosPrivate.post(
    `loja/afiliado/consumidores`,
    {
      idafiliado: id,
      status: status,
      pesquisar: pesquisar,
    },
    { cache: true }
  );

export const editProgramTickets = (id, variacoes) =>
  axiosPrivate.put(
    `loja/programa/ingressos`,
    {
      idprograma: id,
      nidproduto_variacao: variacoes,
    },
    { cache: true }
  );
